<script>
    /* Stores */
	import { alt } from '../store.js';

	/* Components */  
	import Busca from './../components/Busca.svelte';
	import ListaImoveis from './../components/ListaImoveis.svelte'
	import PageHeader from '../components/PageHeader.svelte'

	/* Code */
    let titlePage = 'Lista de Imóveis | ' + $alt;

	//default filters
	let filters = {nt:1, cidade:'Porto Alegre'};

	if (document.location.hash.length > 1) {
		const query = document.location.hash.substring(1).split('&').map(p=>p.split('='));
		for (const p of query) {
			filters[p[0]] = p[1];
		}
	}

	function search(e) {
		if (filters.tipo_negociacao != e.detail.tipo_negociacao) {
			filters = e.detail;
			const url = '/imoveis/' + (e.detail.tipo_negociacao == '1'?'vendas':'locacao') + '#' + Object.entries(e.detail).filter(p=>p[1].length>0).flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
			document.location = url;
		} else {
			filters = e.detail;
			document.location.hash = Object.entries(e.detail).filter(p=>p[1]!=='').flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		}		
	}	
</script>

<svelte:head>
    <title>{titlePage}</title>
</svelte:head>

<h1 class="text-seo">{titlePage}</h1>

<section class="busca">
	<div class="container">	
		<Busca on:filter={search} />
	</div>
</section>

<div class="container">	
	<section class="section lista-imoveis">
		<ListaImoveis filters={filters} />
	</section>
</div>